import { Cell } from 'react-table';

import { CellText } from 'coreOld/elements';
import { AlignText } from 'coreOld/enums';
import { formatDate } from 'coreOld/utils';
import { CostingStatus } from 'partsOld/enums';
import { ICost } from 'partsOld/types';

const statusLabel = {
  [CostingStatus.Active]: 'Active',
  [CostingStatus.Expired]: 'Expired',
  [CostingStatus.Pending]: 'Pending',
};

const getCostItems = (items, uom: string, field: string) => {
  if (!items) {
    return;
  }

  return items.map((item) => {
    if (!item[field]) {
      return;
    }

    return `${parseFloat(item[field])} / ${uom}`;
  });
};

export const columns = [
  {
    Header: 'Start Date',
    accessor: 'startDate',
    Cell: ({ row }: Cell<ICost>) => {
      const date = formatDate(row.original.startDate, true);

      return <CellText mainText={date?.split(' ')[0]} subTexts={[date?.split(' ')[1]]} />;
    },
  },
  {
    Header: 'End Date',
    accessor: 'endDate',
    Cell: ({ row }: Cell<ICost>) => {
      const date = formatDate(row.original.endDate, true);

      return <CellText mainText={date?.split(' ')[0]} subTexts={[date?.split(' ')[1]]} />;
    },
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: ({ row }: Cell<ICost>) => (
      <CellText
        mainText={statusLabel[row.original.status]}
        subTexts={[
          formatDate(row.original.createdAt, true),
          `${row.original.userFirstName} ${row.original.userLastName}`,
        ]}
      />
    ),
  },
  {
    id: 1,
    Header: () => <CellText mainText="Min Qty" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<ICost>) => (
      <CellText
        alignText={AlignText.RIGHT}
        mainText={getCostItems(row.original?.costItems, row.original.uom, 'minQuantity')}
      />
    ),
  },
  {
    id: 2,
    Header: () => <CellText mainText="Max Qty" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<ICost>) => (
      <CellText
        alignText={AlignText.RIGHT}
        mainText={getCostItems(row.original?.costItems, row.original.uom, 'maxQuantity')}
      />
    ),
  },
  {
    id: 3,
    Header: () => <CellText mainText="Cost /Per" alignText={AlignText.RIGHT} />,
    Cell: ({ row }: Cell<ICost>) => (
      <CellText
        alignText={AlignText.RIGHT}
        mainText={getCostItems(row.original?.costItems, row.original.uom, 'cost')}
      />
    ),
  },
];
